<template>
  <div>
    <div class="current_club" v-if="currentClubName">
      <img src="../assets/img/location.svg" alt="" class="club-icon">
      Ваш клуб:
      <span class="current_club_name">{{ currentClubName }}</span>
    </div>
    <div class="current_club" v-if="!currentClubName">
      <span class="current_club_name">Выберите филиал</span>
    </div>
    <div v-if="clubs.length === 0">{{ emptyText }}</div>
    <div class="fitbase-clubs_list">
      <div class="club_item" v-for="club in clubs"
          :key="club.id"
          :class="{ active: club.id === (selectedClubId ?? $store.state.user.current_club) }"
          @click="handleClick(club.id)"
      >
        <div class="club_data">
          <div class="club_name">
            {{ club.name }}
          </div>
          <div v-if="club.address.length !== 0" class="club_address">
            {{ club.address }}
          </div>
        </div>
        <div class="club_icon">
          <img src="../assets/img/check.svg" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    currentClubName() {
      const currentClubId = this.$store.state.user.current_club;
      const currentClub = this.clubs.find(club => club.id === currentClubId);
      return currentClub ? currentClub.name : null;
    },
  },
  props: {
    clubs: Array,
    emptyText: String,
    onClubSelect: Function,
    selectedClubId: Number,
  },
  methods: {
    handleClick(id) {
      if (this.onClubSelect) {
        this.onClubSelect(id);
      }
      this.$emit('select-club-id', id);
    }
  }
}
</script>
